function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.61111 16.1699C2.61111 13.0705 5.23231 11.7613 5.25866 11.7482L19.9585 3.5612C19.9585 3.5612 21.1795 2.64614 23.4424 2.64614C25.7054 2.64614 27.0415 3.56121 27.0415 3.56121L41.7414 11.7481C41.7414 11.7481 44.3889 13.3495 44.3889 16.1699V42.5307C44.3889 46.2993 41.2195 49.3543 37.3099 49.3543H9.69012C5.78049 49.3543 2.61111 46.2993 2.61111 42.5307V16.1699ZM42.411 10.6116C43.0801 9.4764 43.0808 9.47682 43.0815 9.47724L43.0832 9.47832L43.087 9.48062L43.0954 9.48572L43.115 9.49787C43.1295 9.50685 43.1465 9.5176 43.166 9.53009C43.2051 9.55507 43.254 9.58718 43.3116 9.62634C43.4263 9.70448 43.5767 9.81187 43.7509 9.94814C44.0956 10.2179 44.5529 10.6159 45.0148 11.1414C45.9214 12.1726 47 13.8793 47 16.1699V42.5307C47 47.8836 42.5371 52.0002 37.3099 52.0002H9.69012C4.46291 52.0002 0 47.8836 0 42.5307V16.1699C0 13.7782 1.03701 12.0555 2.02935 10.982C2.51858 10.4528 3.00529 10.0692 3.37611 9.81353C3.56326 9.68447 3.72606 9.58442 3.85213 9.5116C3.91534 9.4751 3.96981 9.44515 4.01408 9.42157C4.02167 9.41753 4.02896 9.41367 4.03596 9.40999L18.5981 1.2997C18.6787 1.24663 18.7795 1.18373 18.9001 1.11466C19.1518 0.970543 19.4914 0.798712 19.9161 0.633523C20.7691 0.301722 21.9567 0.000244141 23.4424 0.000244141C24.925 0.000244141 26.1291 0.300438 26.9879 0.618938C27.4169 0.778025 27.7615 0.942247 28.0149 1.07757C28.1417 1.14533 28.2463 1.20617 28.3279 1.25599C28.3422 1.26472 28.3557 1.27311 28.3686 1.28115L43.0398 9.45204L43.0797 9.47619L42.411 10.6116C42.411 10.6116 42.411 10.6116 42.411 10.6116Z",
  fill: "url(#paint0_radial_456_1776)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.6839 25.6977C38.4387 26.7203 38.4387 29.2802 36.6839 30.3028L18.9424 40.6411C17.1896 41.6625 15 40.3837 15 38.3385L15 17.6619C15 15.6168 17.1896 14.338 18.9424 15.3594L36.6839 25.6977Z",
  fill: "url(#paint2_radial_456_1776)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_456_1776",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(2.61111 2.64592) rotate(48.1894) scale(62.6663 51.2674)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0760668
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.578125,
  stopColor: "#FF0000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_angular_456_1776",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(2.61111 49.3544) rotate(90) scale(146.862 131.359)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.046875,
  stopColor: "#FF0000",
  stopOpacity: 0.72
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.244792
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.421875,
  stopColor: "#FF0000",
  stopOpacity: 0.72
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.671875,
  stopColor: "#FF0000",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.802083,
  stopColor: "#FF0000",
  stopOpacity: 0.72
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.892984
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_456_1776",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(40.6354 10.7512) rotate(134.735) scale(48.5636 39.9757)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0760668
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.578125,
  stopColor: "#D80303"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_angular_456_1776",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.45501 10.7512) rotate(-180) scale(107.471 108.47)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.046875,
  stopColor: "#FF0000",
  stopOpacity: 0.72
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.244792
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.421875,
  stopColor: "#FF0000",
  stopOpacity: 0.72
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.671875,
  stopColor: "#FF0000",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.802083,
  stopColor: "#FF0000",
  stopOpacity: 0.72
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.892984
})));

var SvgLogoMini = function SvgLogoMini(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 52,
    viewBox: "0 0 47 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.61111 16.1699C2.61111 13.0705 5.23231 11.7613 5.25866 11.7482L19.9585 3.5612C19.9585 3.5612 21.1795 2.64614 23.4424 2.64614C25.7054 2.64614 27.0415 3.56121 27.0415 3.56121L41.7414 11.7481C41.7414 11.7481 44.3889 13.3495 44.3889 16.1699V42.5307C44.3889 46.2993 41.2195 49.3543 37.3099 49.3543H9.69012C5.78049 49.3543 2.61111 46.2993 2.61111 42.5307V16.1699ZM42.411 10.6116C43.0801 9.4764 43.0808 9.47682 43.0815 9.47724L43.0832 9.47832L43.087 9.48062L43.0954 9.48572L43.115 9.49787C43.1295 9.50685 43.1465 9.5176 43.166 9.53009C43.2051 9.55507 43.254 9.58718 43.3116 9.62634C43.4263 9.70448 43.5767 9.81187 43.7509 9.94814C44.0956 10.2179 44.5529 10.6159 45.0148 11.1414C45.9214 12.1726 47 13.8793 47 16.1699V42.5307C47 47.8836 42.5371 52.0002 37.3099 52.0002H9.69012C4.46291 52.0002 0 47.8836 0 42.5307V16.1699C0 13.7782 1.03701 12.0555 2.02935 10.982C2.51858 10.4528 3.00529 10.0692 3.37611 9.81353C3.56326 9.68447 3.72606 9.58442 3.85213 9.5116C3.91534 9.4751 3.96981 9.44515 4.01408 9.42157C4.02167 9.41753 4.02896 9.41367 4.03596 9.40999L18.5981 1.2997C18.6787 1.24663 18.7795 1.18373 18.9001 1.11466C19.1518 0.970543 19.4914 0.798712 19.9161 0.633523C20.7691 0.301722 21.9567 0.000244141 23.4424 0.000244141C24.925 0.000244141 26.1291 0.300438 26.9879 0.618938C27.4169 0.778025 27.7615 0.942247 28.0149 1.07757C28.1417 1.14533 28.2463 1.20617 28.3279 1.25599C28.3422 1.26472 28.3557 1.27311 28.3686 1.28115L43.0398 9.45204L43.0797 9.47619L42.411 10.6116C42.411 10.6116 42.411 10.6116 42.411 10.6116Z",
    fill: "url(#paint1_angular_456_1776)",
    style: {
      mixBlendMode: "screen"
    }
  }), _ref3, /*#__PURE__*/React.createElement("path", {
    d: "M36.6839 25.6977C38.4387 26.7203 38.4387 29.2802 36.6839 30.3028L18.9424 40.6411C17.1896 41.6625 15 40.3837 15 38.3385L15 17.6619C15 15.6168 17.1896 14.338 18.9424 15.3594L36.6839 25.6977Z",
    fill: "url(#paint3_angular_456_1776)",
    style: {
      mixBlendMode: "screen"
    }
  }), _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoMini, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_mini.102287aa.svg";
export { ForwardRef as ReactComponent };